export enum COMPANYSTATUS {
  REJECTED = "REJECTED",
  ON_REVIEW = "ON REVIEW",
  ACTIVE = "ACTIVE",
  APPROVED = "APPROVED",
}
